import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCollapsePanel = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M13.4141 9.17188C13.8045 8.78142 14.4376 8.78155 14.8281 9.17188C15.2186 9.5624 15.2186 10.1954 14.8281 10.5859L14.4141 11H16.9502C17.5022 11.0002 17.949 11.448 17.9492 12C17.9492 12.5521 17.5023 12.9998 16.9502 13H14.4141L14.8281 13.415C15.2186 13.8056 15.2186 14.4386 14.8281 14.8291C14.4376 15.2193 13.8045 15.2195 13.4141 14.8291L11.293 12.707C10.9026 12.3165 10.9025 11.6834 11.293 11.293L13.4141 9.17188Z",
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M20 2C21.1046 2 22 2.89543 22 4V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V4C2 2.89543 2.89543 2 4 2H20ZM4 20H7V4H4V20ZM9 20H20V4H9V20Z",
		fill: "white"
	})]
});
export default SvgCollapsePanel;
